<template>
    <b-modal
        ref="columns-selector"
        cancel-variant="outline-secondary"
        size="md"
        ok-title="Close"
        ok-only
        centered
        title="Columns to display"
    >
        <b-list-group flush>
            <b-list-group-item href="#" @click="switchFieldState(field)" v-for="field in fields">
                <b-form-checkbox
                    v-model="activeFields"
                    :value="field"
                    @change="switchFieldState"
                >{{ field.label }}</b-form-checkbox>
            </b-list-group-item>
        </b-list-group>
    </b-modal>
</template>

<script>
import { BFormCheckbox, BListGroup, BListGroupItem } from 'bootstrap-vue'

export default {
    components: {
        BListGroup, BListGroupItem, BFormCheckbox,
    },
    props: {
        fields: {
            type: Array,
            required: true
        },
        activeFields: {
            type: Array,
            required: true
        }
    },
    methods: {
        switchFieldState(field) {
            let index = this.activeFields.findIndex(f => f.key === field.key);

            if (index > -1) {
                this.$emit('inactivate', index, this.activeFields[index]);
            } else {
                this.$emit('activate', field);
            }
        },
        show() {
            this.$refs['columns-selector'].show();
        },
    }
}
</script>
